// PriceFormat.js
import React, { createContext, useEffect, useState, useContext } from "react";

const countryToCurrency = {
  TR: "TRY",
  US: "USD",
  CA: "USD",
  MX: "USD",
  DE: "EUR",
  FR: "EUR",
  NL: "EUR",
  IT: "EUR",
  ES: "EUR",
  PL: "EUR",
  PT: "EUR",
  GR: "EUR",
  BE: "EUR",
  AT: "EUR",
  IE: "EUR",
  FI: "EUR",
  GB: "GBP",
};

const CurrencyContext = createContext();

export const PriceFormatProvider = ({ children }) => {
  const [currency, setCurrency] = useState("TRY");
  const [conversionRate, setConversionRate] = useState(1);
  const [currencyRates, setCurrencyRates] = useState({
    USD: 1,
    TRY: 46,
    EUR: 0.91,
    GBP: 0.81,
  });

  const getCurrencyByCountry = (cc) => {
    const cur = countryToCurrency[String(cc || "").toUpperCase()];
    return ["TRY", "USD", "EUR", "GBP"].includes(cur) ? cur : "USD";
  };

  // küçük yardımcı: timeout'lu fetch + JSON
  const fetchJSON = async (url, { timeout = 5000 } = {}) => {
    const ctrl = new AbortController();
    const id = setTimeout(() => ctrl.abort(), timeout);
    try {
      const res = await fetch(url, { signal: ctrl.signal });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return await res.json();
    } finally {
      clearTimeout(id);
    }
  };

  // 1) Kurları backend'den çek
  useEffect(() => {
    (async () => {
      try {
        const data = await fetchJSON(`${process.env.REACT_APP_API_URL}/rates`, {
          timeout: 4000,
        });
        // Beklenen anahtarlar gelmezse fallback'leri koru
        setCurrencyRates((prev) => ({
          USD: Number(data.USD) || prev.USD,
          TRY: Number(data.TRY) || prev.TRY,
          EUR: Number(data.EUR) || prev.EUR,
          GBP: Number(data.GBP) || prev.GBP,
        }));
      } catch {
        // sessizce fallback tabloda kal
      }
    })();
  }, []);

  // 2) Lokasyona göre currency seç (ipwho.is -> ipapi.co -> TRY)
  useEffect(() => {
    (async () => {
      try {
        // 1. deneme: ipwho.is
        const a = await fetchJSON("https://ipwho.is/", { timeout: 4000 });
        const cc =
          a?.country_code || a?.country_code_iso3 || a?.country_code_iso2;
        const cur = getCurrencyByCountry(cc);
        setCurrency(cur);
      } catch {
        try {
          // 2. deneme: ipapi.co
          const b = await fetchJSON("https://ipapi.co/json/", {
            timeout: 4000,
          });
          const cur = getCurrencyByCountry(b?.country_code);
          setCurrency(cur);
        } catch {
          // 3. fallback
          setCurrency("TRY");
        }
      }
    })();
  }, []);

  // 3) Seçilen para birimine göre conversionRate'i güncelle
  useEffect(() => {
    setConversionRate(currencyRates[currency] ?? 1);
  }, [currency, currencyRates]);

  return (
    <CurrencyContext.Provider value={{ currency, conversionRate }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
